import * as UpdateInvestmentTypes from 'src/actions/investment/update/Types';
import { UpdateInvestmentAction } from 'src/actions/investment/update/UpdateInvestment.actions';

export interface UpdateInvestmentState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: UpdateInvestmentState = {
  loading: false,
  error: false,
  errorMessage: {},
};

export function UpdateInvestmentReducer(state: UpdateInvestmentState = initialState,
                                        action: UpdateInvestmentAction): UpdateInvestmentState {
  switch (action.type) {
    case UpdateInvestmentTypes.UPDATE_INVESTMENT_ATTEMPT:
      return {...state, loading: true, error: false};
    case UpdateInvestmentTypes.UPDATE_INVESTMENT_SUCCESS:
      return {...state, loading: false, error: false};
    case UpdateInvestmentTypes.UPDATE_INVESTMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/investment/UpdateInvestmentReducer.tsx